import {CreateOperationalEntityResult} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreateResult} from "../view-model";

export const toCreateResult = (
  result: CreateOperationalEntityResult
): CreateResult => ({
  caId: result.sources[0].sourceId,
  oeId: result.id,
  dbaName: result.dbaName,
  tenantId: "",
  //TODO: This conditional is only needed until the code freeze is over and we can push a model update to CreateOperationalEntityResult to only include the 3 statuses that are possible now.
  status: result.status === "created" ? "created" : "failed",
  message: result.message
});
